import { PhxIconModule } from '../icon/icon.module';
import { PhxDropdownModule } from '../dropdown/phx-dropdown.module';
import { PhxTooltipModule } from '../tooltip/phx-tooltip.module';
import { PhxTranslationsRootModule } from '../../translation/transloco-root.module';
import { PhxDatePickerComponent } from './phx-date-picker.component';
import { PhxDatePickerInputComponent } from './phx-date-picker-input.component';
import { PhxDatePickerHeaderComponent } from './header/header.component';
import { PhxDatePickerFooterComponent } from './footer/footer.component';
import { PhxDatePickerBodyComponent } from './body/body.component';
import { PhxDatePickerMenuComponent } from './menu/menu.component';
import { PhxFocusableItemDirective } from './phx-focusable-item.directive';
import { PhxYearPickerBodyComponent } from './year-picker/phx-year-picker.body.component';
import { PhxMonthPickerModule } from '../month-picker/phx-month-picker.module';
import { PhxButtonModule } from '../button/phx-button.module';
import { PhxDialogModule } from '../dialog/phx-dialog.module';
import { PhxIconButtonModule } from '../icon-button/phx-icon-button.module';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';
import { A11yModule } from '@angular/cdk/a11y';
import { PhxTranslatePipe } from '../../translation/phx-translation.pipe';

@NgModule({
  declarations: [
    PhxDatePickerComponent,
    PhxDatePickerInputComponent,
    PhxDatePickerBodyComponent,
    PhxDatePickerHeaderComponent,
    PhxDatePickerFooterComponent,
    PhxYearPickerBodyComponent,
    PhxDatePickerMenuComponent,
    PhxFocusableItemDirective,
  ],
  imports: [
    CommonModule,
    FormsModule,
    OverlayModule,
    PhxIconModule,
    PhxDropdownModule,
    A11yModule,
    PhxTranslationsRootModule,
    PhxTooltipModule,
    PhxMonthPickerModule,
    PhxButtonModule,
    PhxDialogModule,
    PhxIconButtonModule,
  ],
  providers: [PhxTranslatePipe],
  exports: [PhxDatePickerComponent, PhxDatePickerInputComponent, PhxIconModule],
})
export class PhxDatePickerModule {}
